import { frontendURL } from '../../../helper/URLHelper';
const CanalesView = () => import('./CanalesView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/canales'),
      name: 'canales_view',
      component: CanalesView,
      meta: { permissions: ['administrator'] },
    },
  ],
};
